// Your Summary And Greeting Section

import emoji from "react-easy-emoji";

const greeting = {
  /* Your Summary And Greeting Section */
  username: "Berhane Yohannes",
  title: "Hi all, I'm Yohannes",
  subTitle: emoji(
    "A passionate Full Stack Developer 🚀 having an experience of building Web applications with JavaScript / Reactjs / Nodejs and some other cool libraries and frameworks."
  ),
  resumeLink:
    "https://drive.google.com/file/d/1jA_RkkYiEnTu6ZQ6RKZrdwbKaVP--OOf/view?usp=sharing",
};

// Your Social Media Link

const socialMediaLinks = {
  github: "https://github.com/byohannes",
  linkedin: "https://www.linkedin.com/in/byohannes/",
  gmail: "byohannes44@gmail.com",
  gitlab: "https://gitlab.com/byohannes",
  facebook: "https://www.facebook.com/berhane.feki",
};

// Your Skills Section

const skillsSection = {
  title: "What i do",
  subTitle:
    "PASSIONATE FULL STACK DEVELOPER WHO WANTS TO EXPLORE EVERY TECH STACK",
  skills: [
    emoji(
      "⚡ Develop highly interactive Front end / User Interfaces for your web applications"
    ),
    emoji("⚡ Writing clean, functional code on the front- and back-end"),
    emoji(
      "⚡ Integration of third party services such as Firebase/ AWS / Heroku"
    ),
  ],

  /* Make Sure You include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "html-5",
      fontAwesomeClassname: "fab fa-html5",
    },
    {
      skillName: "css3",
      fontAwesomeClassname: "fab fa-css3-alt",
    },
    {
      skillName: "sass",
      fontAwesomeClassname: "fab fa-sass",
    },
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js",
    },

    {
      skillName: "reactjs",
      fontAwesomeClassname: "fab fa-react",
    },
    {
      skillName: "nodejs",
      fontAwesomeClassname: "fab fa-node",
    },
    {
      skillName: "npm",
      fontAwesomeClassname: "fab fa-npm",
    },
    {
      skillName: "MongoDB",
      fontAwesomeClassname: "fab fa-envira",
    },
    {
      skillName: "PostgreSQL",
      fontAwesomeClassname: "fas fa-database",
    },
    {
      skillName: "aws",
      fontAwesomeClassname: "fab fa-aws",
    },
    {
      skillName: "firebase",
      fontAwesomeClassname: "fas fa-fire",
    },
    {
      skillName: "docker",
      fontAwesomeClassname: "fab fa-docker",
    },
  ],
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Frontend/Design", //Insert stack or technology you have experience in
      progressPercentage: "90%", //Insert relative proficiency in percentage
    },
    {
      Stack: "Backend",
      progressPercentage: "70%",
    },
    {
      Stack: "Programming",
      progressPercentage: "60%",
    },
  ],
};

// Your top 3 work experiences

const workExperiences = {
  viewExperiences: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Junior Fullstack Developer",
      company: "CodeYourFuture",
      companylogo: require("./assets/images/CYFLogo.png"),
      date: "SEP. 2020 – Present",
      desc:
        "working on a project within a team of senior and junior developers developing and building web applications . Collaboratively working in an agile environment in a team of six using tools such as Trello, Slack, and Github to communicate within the team to attain our goal.",
    },
    {
      role: "Data Analyst",
      company: "Midas Touch Business Services Ltd.",
      companylogo: require("./assets/images/middas.png"),
      date: "JUN. 2015 – AUG. 2015",
      desc:
        "Placement position where responsibilities included formulating reports on accumulated data, and      identifying and resolving queries and problems related to stories. Enhanced performance through managing databases and utilizing advanced Excel functions to generate spreadsheets and pivot tables. I managed two significant projects to reorganize and update the database platform to improve data security and the effectiveness of data integration and additionally delivered robust support to managers to determine the capabilities and processes that drive continuous improvement.",
    },
    {
      role: "Junior Software Developer",
      company: "Omdurman Hospital",
      companylogo: require("./assets/images/omdurman.png"),
      date: "MAY. 2009 – AUG. 2010",
      desc:
        "The role involved working within a team of four, as a group and individually, developing high-quality code to produce functional software applications; one of the many projects revolved around the development of a computerized Hospital Management System containing several modules. Modules covered areas such as Outpatient doctor appointments; Inpatient medical services treatments.",
    },
  ],
};

// Your Achievement Section Include Your Certification Talks and More

const achievementSection = {
  title: "Projects ",
  subtitle: "Applications and Some Cool Stuff that I have done !",

  achievementsCards: [
    {
      title: "Amazon Clone",
      subtitle:
        "created a FULL Amazon website clone with full e-commerce functionality using React js, firebase and stripe payment",
      image: require("./assets/images/projects/amazon-clone.png"),
      footerLink: [
        {
          name: "Github Repo",
          url: "https://github.com/byohannes/amazon-clone",
        },
        {
          name: "APP Link",
          url: "https://challenge-7dcc8.web.app/",
        },
      ],
    },
    {
      title: "Class Planner",
      subtitle:
        "This project's aim is to streamline and automate the process that codeYourFuture use to sign up volunteers to attend classes, using Reactjs, Nodejs, Expressjs and mongoDB technologies.",
      image: require("./assets/images/projects/classplanner.jpg"),
      footerLink: [
        {
          name: "Github Repo",
          url: "https://github.com/CodeYourFuture/Class-Planner",
        },
        {
          name: "APP Link",
          url: "https://classplanner.codeyourfuture.io/",
        },
      ],
    },
    {
      title: "DEV Connector",
      subtitle:
        "This is a MERN stack application from the MERN Stack Front To Back course on Udemy. It is a small social network app that includes authentication, profiles and forum posts",
      image: require("./assets/images/projects/devconnector.png"),
      footerLink: [
        {
          name: "Github Repo",
          url: "https://github.com/byohannes/EriDevConnector",
        },
        {
          name: "APP Link",
          url: "https://eridev-connector.herokuapp.com/",
        },
      ],
    },
    {
      title: "Extra Support",
      subtitle:
        "This an app that connect students with professionals where a professional can offer their service for students, using Reactjs, Nodejs, Expressjs and mongoDB technologies.",
      image: require("./assets/images/projects/extrasupport.jpg"),
      footerLink: [
        {
          name: "Github Repo",
          url: "https://github.com/CodeYourFuture/extra-support",
        },
        {
          name: "APP Link",
          url: "https://extra-support.staging.codeyourfuture.io/",
        },
      ],
    },
    {
      title: "COVID-19 Tracker",
      subtitle:
        "created a COVID-19 Tracker/Stats Application using React with the addition of Charts.js, Material UI, and many different modules",
      image: require("./assets/images/projects/covid.png"),
      footerLink: [
        {
          name: "Github Repo",
          url: "https://github.com/byohannes/COVID-Tracker-React",
        },
        {
          name: "APP Link",
          url: "https://byohannes-covid-tracker.netlify.app/",
        },
      ],
    },
    {
      title: "Book Store",
      subtitle:
        "created a book store ecommerce application in Reactjs, Nodejs, Expressjs and mondoDB",
      image: require("./assets/images/projects/ecommerce.png"),
      footerLink: [
        {
          name: "Github Repo",
          url: "https://github.com/byohannes/ecommerce",
        },
        {
          name: "APP Link",
          url: "https://library-shop.herokuapp.com/",
        },
      ],
    },
    {
      title: "Countries APP",
      subtitle: "created a world countries information application in React js",
      image: require("./assets/images/projects/countries.jpg"),
      footerLink: [
        {
          name: "Github Repo",
          url: "https://github.com/byohannes/countries-project",
        },
        {
          name: "APP Link",
          url: "https://cyf-byohannes-countries.netlify.app/",
        },
      ],
    },
    {
      title: "Job Listings App",
      subtitle: "created a job listing application in React js",
      image: require("./assets/images/projects/jobsearch.jpg"),
      footerLink: [
        {
          name: "Github Repo",
          url: "https://github.com/byohannes/job-listings-react",
        },
        {
          name: "APP Link",
          url: "https://cyf-byohannes-jobs.netlify.app/",
        },
      ],
    },
    {
      title: "Baby Names APP",
      subtitle: "created a Baby Names application in React js",
      image: require("./assets/images/projects/babyname.jpg"),
      footerLink: [
        {
          name: "Github Repo",
          url: "https://github.com/byohannes/baby-names-react",
        },
        {
          name: "APP Link",
          url: "https://cyf-byohannes-baby-names.netlify.app/",
        },
      ],
    },
    {
      title: "Movies APP",
      subtitle:
        "created a movies application in vanilla javascript, HTML and CSS",
      image: require("./assets/images/projects/tv.png"),
      footerLink: [
        {
          name: "Github Repo",
          url: "https://github.com/byohannes/tv-show-dom-project",
        },
        {
          name: "APP Link",
          url: "https://cyf-byohannes-tv.netlify.app/",
        },
      ],
    },
    {
      title: "Tic-Tac-Toe Game APP",
      subtitle: "created a Tic-Tac-Toe game application in React js",
      image: require("./assets/images/projects/tic-tac.png"),
      footerLink: [
        {
          name: "Github Repo",
          url: "https://github.com/byohannes/tic-tac-react",
        },
        {
          name: "APP Link",
          url: "https://tictactoe-reacthooks.netlify.app/",
        },
      ],
    },
    {
      title: "Hotel APP",
      subtitle: "created a hotel booking application in React js",
      image: require("./assets/images/projects/hotel.jpg"),
      footerLink: [
        {
          name: "Github Repo",
          url: "https://github.com/byohannes/cyf-hotel-react",
        },
        {
          name: "APP Link",
          url: "https://cyf-byohannes-hotel-react.netlify.app/",
        },
      ],
    },
  ],
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Discuss a project or just want to say hi? My Inbox is open for all.",
  number: "+447453125196",
  email_address: "byohannes44@gmail.com",
  opportunity: "Open for opportunities: Yes",
};

export {
  greeting,
  socialMediaLinks,
  skillsSection,
  techStack,
  workExperiences,
  achievementSection,
  contactInfo,
};
